@if (faqs.length > 0) {
  <div class="help-card">
    <span class="dot">?</span>
    <div class="help-content">
      @if (pageHeader) {
        <div class="help-head">
          {{ pageHeader }}
        </div>
      }
      @for (faq of faqs; track faq) {
        <details>
          <summary>{{ faq.question }}<span class="chev">▸</span></summary>
          <span class="answer" [innerHTML]="faq.answer"></span>
        </details>
      }
    </div>
  </div>
}
